import { createSlice } from '@reduxjs/toolkit';

import { updateMailingToggle } from '../services';
import { IMailingToggle } from '../types/mailingToggles';

export enum EMailingToggleStatus {
  Initial = 'initial',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export type IMailingTogglesState = {
  toggles: IMailingToggle[];
  updateMailingToggleStatus: EMailingToggleStatus;
};

const initialState: IMailingTogglesState = {
  toggles: [],
  updateMailingToggleStatus: EMailingToggleStatus.Initial,
};

const mailingTogglesSlice = createSlice({
  name: 'mailingToggles',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(updateMailingToggle.pending, state => {
        state.updateMailingToggleStatus = EMailingToggleStatus.Loading;
      })
      .addCase(updateMailingToggle.fulfilled, (state, action) => {
        state.toggles = state.toggles.map(toggle =>
          toggle.id === action.payload.id ? { ...toggle, isActive: action.payload.isActive } : toggle,
        );
        state.updateMailingToggleStatus = EMailingToggleStatus.Success;
      })
      .addCase(updateMailingToggle.rejected, state => {
        state.updateMailingToggleStatus = EMailingToggleStatus.Error;
      });
  },
  selectors: {
    selectMailingToggles: (state: IMailingTogglesState) => state.toggles,
  },
});

export const {
  reducer: mailingTogglesReducer,
  selectors: { selectMailingToggles },
} = mailingTogglesSlice;
